export default "/assets/images/opened-unit.webp?309181bc927fc152cc31c7bd58db50a9";